"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzInput = void 0;

var react_1 = __importStar(require("react"));

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

var SzButton_1 = __importDefault(require("../SzButton/SzButton"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

var SzTooltip_1 = __importDefault(require("../SzTooltip/SzTooltip"));

var SzTypographie_1 = __importDefault(require("../SzTypographie/SzTypographie"));

require("./SzInput.scss");

exports.SzInput = react_1.forwardRef(function (props, ref) {
  var name = props.name,
      autocomplete = props.autocomplete,
      id = props.id,
      value = props.value,
      label = props.label,
      className = props.className,
      variant = props.variant,
      small = props.small,
      border = props.border,
      error = props.error,
      icon = props.icon,
      showPassword = props.showPassword,
      type = props.type,
      info = props.info,
      infoPosition = props.infoPosition,
      infoDetached = props.infoDetached,
      valid = props.valid,
      handleClear = props.handleClear,
      leftProps = __rest(props, ["name", "autocomplete", "id", "value", "label", "className", "variant", "small", "border", "error", "icon", "showPassword", "type", "info", "infoPosition", "infoDetached", "valid", "handleClear"]);

  var _a = __read(react_1.useState(type), 2),
      localType = _a[0],
      setlocalType = _a[1];

  var _b = __read(react_1.useState(false), 2),
      showInfo = _b[0],
      setShowInfo = _b[1];

  var toggleLocalType = function toggleLocalType() {
    return setlocalType(localType === 'password' ? 'text' : 'password');
  };

  var formGroupClasses = classnames_1.default('sz-form-group', {
    'form-group-outlined': variant && 'outlined' === variant,
    'form-group-small': small
  });
  var labelClasses = classnames_1.default({
    'sz-line-height-normal': !(info && infoPosition === 'label'),
    'sz-form-group__label': !variant,
    'mb-1': !variant,
    'mb-2': variant
  });
  var inputClasses = classnames_1.default({
    'sz-form-group__input': !variant,
    'input-small': small && variant && 'outlined' === variant,
    'bg-white text-primary-dark': value.length > 0,
    'border-btn-disabled': value.length > 0 && !error,
    'pl-5': icon,
    'pr-5': valid || variant && 'outlined' === variant,
    'pr-3': showPassword,
    'border-danger': error && value.length > 0,
    'border-soft': variant && !border || 'soft' === border,
    'border-rounded': 'rounded' === border
  }, className);
  var iconClasses = classnames_1.default('d-flex position-absolute align-items-center justify-content-center', {
    'sz-form-group__input-icon': !variant,
    'input-icon': variant && 'outlined' === variant,
    'text-primary-dark': value.length > 0 && !error,
    'text-outlined-error': error && variant && 'outlined' === variant
  });
  return react_1.default.createElement("div", {
    className: formGroupClasses
  }, label && react_1.default.createElement("label", {
    className: labelClasses,
    htmlFor: name || id
  }, react_1.default.createElement(SzTypographie_1.default, {
    color: !variant ? 'inactive' : 'dark',
    weight: !variant ? 'bold' : undefined,
    tag: "span"
  }, label), info && infoPosition === 'label' && (infoDetached ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("span", {
    onMouseEnter: function onMouseEnter() {
      return setShowInfo(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowInfo(false);
    }
  }, react_1.default.createElement(SzButton_1.default, {
    className: "ml-1",
    variant: "text",
    icon: "information-circle"
  })), showInfo && react_1.default.createElement("div", {
    className: "pt-2"
  }, info)) : react_1.default.createElement(SzTooltip_1.default, {
    content: info
  }, react_1.default.createElement(SzButton_1.default, {
    className: "ml-1",
    variant: "text",
    icon: "information-circle"
  })))), react_1.default.createElement(react_bootstrap_1.InputGroup, null, react_1.default.createElement(react_bootstrap_1.FormControl, __assign({
    name: name,
    ref: ref,
    autoComplete: autocomplete ? 'on' : 'off',
    type: localType,
    id: id
  }, leftProps, {
    value: value,
    className: inputClasses
  })), icon && react_1.default.createElement("div", {
    className: iconClasses
  }, react_1.default.createElement(SzIcon_1.default, {
    variant: "line",
    icon: icon
  })), showPassword && react_1.default.createElement("div", {
    className: "sz-form-group__input-icon-show position-absolute d-flex align-items-center justify-content-center"
  }, react_1.default.createElement(SzButton_1.default, {
    variant: "tertiary",
    onClick: toggleLocalType,
    icon: localType === 'password' ? 'view-1' : 'view-off'
  })), info && infoPosition === 'input' && react_1.default.createElement("div", {
    className: "sz-form-group__input-icon-info position-absolute d-flex align-items-center justify-content-center"
  }, react_1.default.createElement(SzTooltip_1.default, {
    content: info
  }, react_1.default.createElement(SzButton_1.default, {
    variant: "tertiary",
    icon: "information-circle"
  }))), valid && value.length > 0 && react_1.default.createElement("div", {
    className: "sz-form-group__input-icon-valid bg-white position-absolute d-flex align-items-center justify-content-center text-success px-3"
  }, react_1.default.createElement(SzIcon_1.default, {
    icon: "check-circle-1",
    variant: "line"
  })), handleClear && value.length > 0 && react_1.default.createElement("div", {
    className: "sz-form-group__input-icon-clear bg-white position-absolute d-flex align-items-center justify-content-center"
  }, react_1.default.createElement(SzButton_1.default, {
    onClick: handleClear,
    variant: "tertiary",
    icon: "remove"
  }))));
});
exports.SzInput.defaultProps = {
  disabled: false,
  required: false,
  placeholder: '',
  type: 'text',
  value: '',
  name: '',
  showPassword: false,
  readOnly: false,
  infoPosition: 'input',
  infoDetached: false
};
exports.default = exports.SzInput;